import Bugsnag, { NotifiableError } from '@bugsnag/js';
import { redactPublishedAccess } from '../publishedAccessRedaction';

export function bugsnagNotify(error: NotifiableError) {
    if (bugSnagData.isEnabled) {
        Bugsnag.notify(error, function(event) {
            event.context = redactPublishedAccess(event.context);
            if (event?.originalError?.isAxiosError) {
                event.addMetadata('axios', {
                    config: sanitizeAxiosMetadata(event.originalError.config),
                    response: sanitizeAxiosMetadata(event.originalError.response),
                });
            }
            return true;
        });
    }
}

function sanitizeAxiosMetadata(value: any): any {
    if (!value) {
        return value;
    }

    return redactPublishedAccess(value);
}
